import { call, post } from "@/services/api";

export type Movement = {
  id: number; kit_code: string | null; label: string | null; article_reference: string | null;
  myotaku_warehouse_id: number; previous_qty: number; qty: number; delta: number;
  source: "production" | "restock" | "transfer" | "delivery" | "inventory" | "receipt" | "manual" | "correction" | "plus_minus";
  by_name: string | null; at: string;
  // His kit history: a delivery's client and contract, and what an exit could not take.
  client_name?: string | null; contract_id?: number | null; shortfall?: number;
  // His article history's detail: the order, the supplier and receipt, the warehouses of a transfer.
  order_id?: number | null; order_kit?: string | null; order_qty?: number | null;
  supplier?: string | null; receipt_id?: number | null; from_warehouse_id?: number | null; to_warehouse_id?: number | null;
};
export type Inventory = {
  id: number; myotaku_warehouse_id: number; counted_by: string | null; counted_at: string; note: string | null;
  lines: { kit_code: string | null; article_reference: string | null; label: string | null; expected: number; counted: number; delta: number }[];
};

const q = (w?: number | null) => (w ? `?warehouse_id=${w}` : "");
export const fetchMovements = (w?: number | null) => call<{ movements: Movement[] }>(`/api/v1/stock_movements${q(w)}`);
export const fetchKitHistory = () => call<{ movements: Movement[] }>(`/api/v1/stock_movements?kits=1`);
export const fetchKitMovements = (kit: string, w?: number | null) =>
  call<{ movements: Movement[] }>(`/api/v1/stock_movements?kit_code=${encodeURIComponent(kit)}${w ? `&warehouse_id=${w}` : ""}`);
export const fetchInventories = (w?: number | null) => call<{ inventories: Inventory[] }>(`/api/v1/inventories${q(w)}`);
export const createInventory = (b: { warehouse_id: number; lines: { kit_code: string; counted: number }[]; note?: string }) =>
  post<Inventory>(`/api/v1/inventories`, b);
